module.exports = __webpack_public_path__ + "img/95da15b.png";